import React from "react";
import "./AutoScroll.css";

function AutoScroll() {
  return (
    <>
      <div className="lb_lr_slider white">
        <div className="slide-track">
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/10/brands/logos/maruti-suzuki1647009823420.jpg?v=1647009823707&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/8/brands/logos/hyundai.jpg?v=1629973193722&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/16/brands/logos/tata.jpg?v=1629973276336&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/9/brands/logos/mahindra.jpg?v=1629973668273&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/17/brands/logos/toyota.jpg?v=1630055705330&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/70/brands/logos/kia.jpg?v=1630057189593&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/7/brands/logos/honda.jpg?v=1630056209549&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/11/brands/logos/mercedes-benz.jpg?v=1629973270530&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/74/brands/logos/citroen1649763818937.jpg?v=1649763819072&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/20/brands/logos/volkswagen.jpg?v=1630056096439&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/1/brands/logos/bmw.jpg?v=1629973130013&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/15/brands/logos/skoda.jpg?v=1630055414864&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/72/brands/logos/mg.jpg?v=1631163895654&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/23/brands/logos/land-rover1647236056893.jpg?v=1647236057234&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/18/brands/logos/audi.jpg?v=1630055874070&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/37/brands/logos/volvo.jpg?v=1641478299001&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/45/brands/logos/renault.jpg?v=1630057266767&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/43/brands/logos/jeep.jpg?v=1631163646486&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/44/brands/logos/jaguar.jpg?v=1631163525508&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/21/brands/logos/nissan.jpg?v=1631163973143&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/25/brands/logos/rolls-royce.jpg?v=1631164135042&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/cw/brands/logos/lexus.png?v=10&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/30/brands/logos/lamborghini.jpg?v=1631163814246&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/19/brands/logos/porsche.jpg?v=1631164048727&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/73/brands/logos/tesla.jpg?v=1631163609705&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/cw/brands/logos/mini.png?v=10&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/gph63sa_1483779.jpg?q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/n/cw/ec/119/brands/logos/ola1656591185411.jpg?v=1656591185786&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/cw/brands/logos/ferrari.png?v=10&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/cw/brands/logos/bugatti.png?v=10&q=75"
              alt=""
            />
          </div>
          <div className="slide">
            <img
              src="https://imgd.aeplcdn.com/0X0/cw/brands/logos/isuzu.png?v=10&q=75"
              alt=""
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default AutoScroll;

//last is isuzu
